import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=40f43ac8&scoped=true&lang=pug&"
import script from "./checkbox.vue?vue&type=script&lang=coffee&"
export * from "./checkbox.vue?vue&type=script&lang=coffee&"
import style0 from "./checkbox.vue?vue&type=style&index=0&id=40f43ac8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f43ac8",
  null
  
)

export default component.exports